import type { AdicionalTipo } from '@/domain/entities/Adicional';

export const defaultPackName = (tipo: AdicionalTipo): string => {
  if (tipo === 'WHATSAPP_MENSAJES') return 'Recarga WhatsApp';
  if (tipo === 'EMAIL_MENSAJES') return 'Pack Email';
  if (tipo === 'COOFIT_CONEXION') return 'Coofit Conexión';
  if (tipo === 'COOFIT_MARKETING') return 'Coofit Marketing';
  if (tipo === 'COOFIT_WHATSAPP_BOT') return 'Coofit Agenda WhatsApp';
  if (tipo === 'CONSULTORIO_EXTRA') return 'Consultorio extra';
  if (tipo === 'PROFESIONAL_EXTRA') return 'Profesional extra';
  return '';
};

export const packQuantityLabel = (tipo: AdicionalTipo): string =>
  tipo === 'EMAIL_MENSAJES'
    ? 'Emails incluidos por pack'
    : tipo === 'COOFIT_CONEXION'
      ? 'Mensajes WhatsApp incluidos en el escalón'
      : tipo === 'COOFIT_MARKETING'
        ? 'Emails de marketing incluidos en el escalón'
        : tipo === 'COOFIT_WHATSAPP_BOT' || tipo === 'CONSULTORIO_EXTRA' || tipo === 'PROFESIONAL_EXTRA'
          ? 'Sin cupo de mensajes'
          : 'Mensajes WhatsApp de la recarga';

export const packHelpText = (tipo: AdicionalTipo): string =>
  tipo === 'COOFIT_CONEXION'
    ? 'Escalón Conexión: app + push + WA con cupo mensual incluido. Una sola activa por clínica (500/800/1200/1500).'
    : tipo === 'COOFIT_MARKETING'
      ? 'Escalón Marketing: campañas de email con cupo mensual. Una sola activa por clínica. Trial vía bono de cortesía.'
      : tipo === 'COOFIT_WHATSAPP_BOT'
        ? 'Bot que agenda, reprograma y cancela turnos por WhatsApp. Se asigna por clínica desde la ficha comercial.'
        : tipo === 'CONSULTORIO_EXTRA' || tipo === 'PROFESIONAL_EXTRA'
          ? 'Extra del plan. Precio de catálogo. La clínica puede sumarlo desde Coofit (cobro en la próxima factura) o se asigna a mano en la ficha comercial.'
          : tipo === 'EMAIL_MENSAJES'
            ? 'Legacy: packs email. El producto vivo es Coofit Marketing.'
            : 'Recarga de mensajes WhatsApp solo para el mes en curso (caduca al mes siguiente; no es abono).';

export const packDescriptionPlaceholder = (tipo: AdicionalTipo): string =>
  tipo === 'COOFIT_CONEXION'
    ? 'Ej: Coofit Conexión 800 — app + 800 msgs/mes'
    : tipo === 'COOFIT_MARKETING'
      ? 'Ej: Coofit Marketing 500 — 500 emails/mes'
      : tipo === 'COOFIT_WHATSAPP_BOT'
        ? 'Ej: Coofit Agenda WhatsApp — bot de turnos por chat'
        : tipo === 'CONSULTORIO_EXTRA'
          ? 'Ej: Consultorio extra — $15.000/mes'
          : tipo === 'PROFESIONAL_EXTRA'
            ? 'Ej: Profesional extra — $15.000/mes'
            : tipo === 'EMAIL_MENSAJES'
              ? 'Ej: emails adicionales para recordatorios o marketing'
              : 'Ej: Recarga WhatsApp 250 msgs (solo mes actual)';

export const packUnitLabel = (tipo: AdicionalTipo): string =>
  tipo === 'EMAIL_MENSAJES' || tipo === 'COOFIT_MARKETING'
    ? 'emails'
    : tipo === 'COOFIT_CONEXION'
        || tipo === 'COOFIT_WHATSAPP_BOT'
        || tipo === 'CONSULTORIO_EXTRA'
        || tipo === 'PROFESIONAL_EXTRA'
      ? 'mes'
      : 'mensajes';
